export const species = ref<{ label: string; value: string }[]>([
  {
    label: "PM10",
    value: "pm10",
  },
  {
    label: "PM25",
    value: "pm25",
  },
  {
    label: "NO2",
    value: "no2",
  },
]);
export const outputs = ref<{ label: string; value: string }[]>([
  {
    label: "Hour",
    value: "hour",
  },
  {
    label: "Day",
    value: "day",
  },
]);
export const chartTypes = ref<{ label: string; value: string }[]>([
  {
    label: "Line",
    value: "line",
  },
  {
    label: "Bar",
    value: "bar",
  },
]);

export const networks = ref<{ label: string; value: string }[]>([
  {
    label: "LAQN",
    value: "laqn",
  },
  {
    label: "BL",
    value: "bl",
  },
]);
